import React, { type ReactNode } from 'react';

interface ButtonListProps {
    buttons: Array<{
        key: string;
        children: ReactNode;
        onClick?: (event: React.MouseEvent) => void;
        /** When set, the item renders as an anchor so it can be opened in a new tab. */
        href?: string;
    }>;
    className?: string;
    /** Renders shorter, denser rows. */
    compact?: boolean;
}

const ButtonList: React.FC<ButtonListProps> = ({ buttons, className = '', compact = false }) => {
    const sizeClasses = compact ? 'h-8 px-3 py-1.5' : 'h-10 px-3 py-2.5';
    const itemClasses = `flex justify-between items-center w-full no-underline ${sizeClasses}
        bg-[var(--malachite-buttonlist-background)]
        hover:bg-[var(--malachite-buttonlist-hover-background)]
        focus:bg-[var(--malachite-buttonlist-hover-background)]
        active:opacity-60
        border-none rounded-xl shadow-none
        transition-all duration-150 ease-in-out
        cursor-pointer
        text-[var(--malachite-buttonlist-foreground)]
        hover:text-[var(--malachite-buttonlist-hover-foreground)]
        focus:text-[var(--malachite-buttonlist-hover-foreground)]
        focus:outline-none`;

    return (
        <div className={`flex flex-col gap-1 w-full ${className}`}>
            {buttons.map((button) =>
                button.href ? (
                    <a
                        key={button.key}
                        href={button.href}
                        onClick={button.onClick}
                        className={itemClasses}
                    >
                        {button.children}
                    </a>
                ) : (
                    <button
                        key={button.key}
                        type="button"
                        onClick={button.onClick}
                        className={itemClasses}
                    >
                        {button.children}
                    </button>
                ),
            )}
        </div>
    );
};

export default ButtonList;
